import React, { useMemo, useState } from 'react'
import FilterDrawer from 'components/FilterDrawer/FilterDrawer'
import { Filter, FilterAdditionalData } from 'components/FilterDrawer/FilterDrawer.config'
import { FilterOptions } from 'containers/CDTFATablePage/types'
import { FilterOutlined } from '@ant-design/icons'
import styles from './VerticalTableFilters.module.scss'
import cx from 'classnames'

interface VerticalTableFiltersProps {
  activeFilters: Filter[]
  setActiveFilters: React.Dispatch<React.SetStateAction<Filter[]>>
  filtersInitialState: Filter[]
  filterOptions: FilterOptions
  filterAdditionalData: FilterAdditionalData[]
}

const VerticalTableFilters = ({
  activeFilters,
  setActiveFilters,
  filtersInitialState,
  filterOptions,
  filterAdditionalData,
}: VerticalTableFiltersProps) => {
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false)

  const hasActiveFilters = useMemo(() => {
    return activeFilters.length > 0
  }, [activeFilters])

  return (
    <>
      <FilterOutlined
        onClick={() => setIsFilterDrawerOpen(!isFilterDrawerOpen)}
        className={cx(styles.filterIcon, { [styles.filterIconActive]: hasActiveFilters })}
      />
      <FilterDrawer
        open={isFilterDrawerOpen}
        onClose={() => setIsFilterDrawerOpen(false)}
        activeFilters={activeFilters}
        setActiveFilters={setActiveFilters}
        filtersInitialState={filtersInitialState}
        filterOptions={filterOptions}
        filterAdditionalData={filterAdditionalData}
      />
    </>
  )
}

export default VerticalTableFilters
